module.exports = __webpack_public_path__ + "media/images/page/add-circle-line-7d50ecb75d0e1a1540264a3023c08e2c.svg";